


























































































import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment';
import * as api from '@/api';
import * as models from '@/api/models';
import { Dialog, Notify, Toast } from 'vant';
@Component({
  components: {},
})
export default class MyQuestion extends Vue {
  loading: boolean = false;

  finished: boolean = false;

  problemList: any[] = [];

  listData: any = [];

  demo: any = [];

  queryObj: any = {
    pageIndex: 1,
    pageSize: 20,
  };

  get ProblemImportance() {
    return models.ProblemImportance;
  }

  async getListData() {
    this.loading = true;
    try {
      const { data } = await api.Problem.findMyProblems_GET(this.queryObj);
      this.demo = data.items;
      this.queryObj.pageIndex++;
      const list = data.items;
      this.problemList = this.problemList.concat(list);
      if (this.problemList.length == data.totalItemCount || data.items?.length == 0) this.finished = true;
    } finally {
      this.loading = false;
      this.finished = true;
    }
  }

  /**跳转详情 */
  listDetail(item) {
    this.$router.push({
      name: 'AddQuestion',
      query: {
        info: JSON.stringify(item),
        type: 'readonly',
      },
    });
  }

  delProblem(id: string) {
    Dialog.confirm({
      title: '提示 ',
      message: '您确定要删除此条记录吗',
    })
      .then(async () => {
        const { data, success, message } = await api.Problem.deleteByIds_POST({
          ids: [id],
        });
        if (success) {
          const idx = this.problemList.findIndex(item => item.id === id);
          this.problemList.splice(idx, 1);
          Notify({ type: 'primary', message: '删除成功' });
        } else {
          Notify({ type: 'danger', message: '删除失败' });
        }
      })
      .catch(() => {});
  }
}
